import { useEffect } from 'react';

const SetHeaderCssH = () => {
    // 监控header高度 => 其他页面header变化（比如bar条close）之后，更新页面的sticky元素定位top值
    const updateHeaderHeight = () => {
        const elemA = document.querySelector('.ecoflow-frame-header') as HTMLDivElement;
        if (!elemA) {
            return;
        }
        try {
            const height = elemA.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${height}px`);
        } catch (error) {}
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            updateHeaderHeight();
        }
    }, []);

    return null;
};

export default SetHeaderCssH;
